import folderStore from 'owa-folders';
import { actionNames } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
export default function emptyFolderStitch() {
    subscribe(actionNames.EmptyFolderStoreUpdate, function (folderToEmpty, clientLastSyncTime, deletedItemsFolderId) {
        var deletedItemsFolder = folderStore.folderTable.get(deletedItemsFolderId);
        // We update the unread count of the delete folder optimistically too
        // The content of the table will be cleared using the emptyFolderStitch to talk across packages
        deletedItemsFolder.UnreadCount += folderToEmpty.UnreadCount;
        folderToEmpty.UnreadCount = 0;
    });
}
//# sourceMappingURL=emptyFolderStitch.js.map